/** Alphabetical order of titles, ignoring case and reading numbers as numbers ("Java 8" before "Java 17"). */
export function byTitle(a: { title: string }, b: { title: string }): number {
    return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true });
}
